import { Divider, Tag, Text } from "@chakra-ui/react";
import { useAtom } from "jotai";
import { useTranslations } from "next-intl";
import Image from "next/image";
import TicketIcon from "public/images/ticket.svg";
import { selectedTicketAtom } from "utils/atoms";
import { CURRENCY } from "models/selected.model";

const OrderSummary = () => {
  const [selectedTicket] = useAtom(selectedTicketAtom);
  const t = useTranslations("index");

  return (
    <div className="flex flex-col flex-grow justify-start items-center p-4 bg-neutral-900 border-l-[0.5px] border-neutral-600 rounded">
      {selectedTicket ? (
        <div className="flex flex-col flex-grow w-full justify-start items-start p-[1.875rem] gap-10">
          <Text fontSize="lg" fontWeight={600}>
            {t("orderSummary")}{" "}
          </Text>
          <>
            <div className="text-lg font-medium flex flex-row justify-between w-full">
              <div className="flex-shrink">
                {`${selectedTicket.quantity} x ${t(
                  `${selectedTicket.ticket.id}`
                )} `}

                {selectedTicket.ticket.discount && (
                  <Tag bgColor="primary.700">
                    {`${t("priceSave")} ${selectedTicket.discountTagToFixed}%`}
                  </Tag>
                )}
              </div>

              <div className="flex-shrink-0">
                {selectedTicket.total
                  ? `$ ${selectedTicket.totalToFixed} ${CURRENCY}`
                  : "Free"}
              </div>
            </div>

            {selectedTicket?.discount && selectedTicket.totalDiscount !== 0 && (
              <div className="text-lg font-medium flex flex-row justify-between w-full">
                <div className="flex-shrink">{`Promo Discount`}</div>
                <div className="flex-shrink-0">{`- $ ${(selectedTicket?.totalDiscount).toFixed(
                  2
                )} ${CURRENCY}`}</div>
              </div>
            )}

            <div className="flex flex-row justify-between w-full text-2xl">
              <Text fontSize="medium"> Sub-total </Text>
              <Text fontSize="medium">
                {selectedTicket.total
                  ? `$ ${selectedTicket?.payableToFixed} ${CURRENCY}`
                  : "Free"}
              </Text>
            </div>

            {selectedTicket.total !== 0 && (
              <div className="text-lg text-sm flex flex-row justify-between w-full">
                <div className="flex-shrink">
                  Transaction fee ({selectedTicket.transactionFeePct}%)
                </div>
                <div className="flex-shrink-0">{`+ $ ${(selectedTicket?.transactionFee).toFixed(
                  2
                )} ${CURRENCY}`}</div>
              </div>
            )}
          </>
          <>
            <Divider background="#A0A0A7" />
            <div className="flex flex-row justify-between w-full text-2xl">
              <Text> {t("total")} </Text>
              <Text>
                {selectedTicket.total
                  ? `$ ${selectedTicket?.totalPlusTxnFeeToFixed} ${CURRENCY}`
                  : "Free"}
              </Text>
            </div>
          </>
        </div>
      ) : (
        <div className="mt-auto flex flex-col justify-center items-center">
          <div className="w-10 svg-black">
            <Image layout="responsive" src={TicketIcon} alt="hide" />
          </div>
          <Text className="my-1 " fontSize="2md">
            {t("noOrder")}
          </Text>
        </div>
      )}

      <div className="mt-auto self-end"></div>
    </div>
  );
};

export default OrderSummary;
